exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".new-player__cover__cL6wy{background-color:#000;position:absolute;z-index:110}.new-player__player__21d1q{position:relative;background:#000}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/player-widget/components/player/src/widget/player-widget/components/player/new-player.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/player-widget/components/player/new-player.styl"],"names":[],"mappings":"AAEA,0BACE,sBAAA,kBACA,WACA,CAEF,2BACE,kBAAA,eACA,CCDD","file":"new-player.styl","sourcesContent":["@require '~widget/player-widget/styles/mixins'\n\n.cover\n  background-color black\n  position absolute\n  z-index 110\n\n.player\n  position relative\n  background black\n",".cover {\n  background-color: #000;\n  position: absolute;\n  z-index: 110;\n}\n.player {\n  position: relative;\n  background: #000;\n}\n/*# sourceMappingURL=src/widget/player-widget/components/player/new-player.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"cover": "new-player__cover__cL6wy",
	"player": "new-player__player__21d1q"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/new-player.styl
// module id = 2011
// module chunks = 66